<template>
  <div id="app">
    <v-app>
    <poHeader></poHeader>
    
    <router-view :key="$route.fullPath"></router-view>
    <po-footer></po-footer>
    <!-- create Footer  -->
    </v-app>
  </div>
</template>

<script>
import Footer from "./components/Footer.vue";
import Header from "./components/Header.vue";
export default {
  name: "App",

  components: {
    poFooter: Footer,
    poHeader: Header
  },

  data: () => ({
            
        }),
};
</script>
<style scoped>
.container {
  padding: 0;
}
.container-fluid {
  padding: 0;
}
.navbar-light .navbar-nav .nav-link {
  color: rgb(0, 0, 0);
}
body{font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";}
</style>

